import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import analytics from "../../../../context/analytics";

import {
  EventsView,
  GamingView,
  LoyaltyView,
  OffersView,
  QuoteView,
  ReferAndEarnView,
  PeerTalkView,
} from "../../../../components/pulseHome";

// context
import { useTheme, useLoyalty, useSubscriber } from "../../../../hooks";
import useFastestFinger from "../../../../hooks/useFastestFinger";
import { LoyaltyService } from "../../../../services";
import useNewFeatureUpdate from "../../NotificationScreen/hooks/useNewFeatureUpdate";

const useHome = () => {
  //The unhappy feedback questions change based on the feature name you pass to the compleatedFeature State
  const { themeContext, theme } = useTheme();
  const [showFeatureRatings, setShowFeatureRatings] = useState(false);
  const [isFeatureAlert, setIsFeatureAlert] = useState(false);
  const [featureName, setFeatureName] = useState("");
  const [featureRef, setFeatureRef] = useState(null);
  const [isNewNotificationDialog, setIsNewNotificationDialog] = useState(false);
  const [showTaskResumptionModal, setShowTaskResumptionModal] = useState(false);
  const [isOpenOptInRequestDialog, setIsOpenOptInRequestDialog] =
    useState(false);

  const { unreadCount } = useNewFeatureUpdate();

  const {
    loyaltyOffersData,
    loyaltyCheckCode,
    checkOffers,
    getMovieList,
    newFeatureRatings,
    hideNewFeatureRatings,
    getActiveFeatureRatings,
    submitFeatureRatings,
    setSelectedLoyaltyData,
    offerModal,
    setOfferModal,
    checkMovieManiaStatus,
    newInteractions,
    getInteractions,
    hasOptedIn,
    setHasOptedIn,
    submitOptInStatus,
  } = useLoyalty();

  const {
    section,
    title,
    feature,
    feedback,
    _id: interactionID,
    surveyCode,
  } = newInteractions?.data?.length ? newInteractions.data[0] : {};

  const [completedFeature, setCompletedFeature] = useState(false);
  const [isTakeSurveyModalOpen, setIsTakeSurveyModalOpen] = useState(false);

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const params = Object.fromEntries(searchParams);
  const { action, agent, code, tabid } = params || {};

  const { fastestFingerData } = useFastestFinger();

  const {
    fetchUserProfile,
    userProfilephoto,
    userDetails,
    isFetchingUserProfile,
  } = useSubscriber();
  const { canRefer: isUserWhitelisted } = userDetails || {};

  const history = useHistory();

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "Pulse Home",
        firebase_screen_class: "PulseHome",
      })
    );
  }, []);

  useEffect(() => {
    if (loyaltyCheckCode) {
      checkOffers(loyaltyCheckCode);
    }
  }, [loyaltyCheckCode]);

  useEffect(() => {
    if (newInteractions?.data?.length) {
      setCompletedFeature(!newInteractions.data[0].feedback);
    }
  }, [newInteractions?.data?.length]);

  useEffect(() => {
    getMovieList();
    checkMovieManiaStatus();
    getInteractions();
  }, []);

  useEffect(() => {
    if (newFeatureRatings) {
      const { isNew, feature, isRated, isSeen, ref } = newFeatureRatings;

      if (!isNew && !isRated) {
        setCompletedFeature(feature ? feature.toLowerCase() : null);
        setFeatureRef(ref);
        setFeatureName(feature);
      }
    }
  }, [newFeatureRatings]);

  // DETERMINE IF THE CURRENTLY SIGNED IN USER WON IN THE CAPTURE AND SHARE PROMO. IF THEY DID, SHOW THEM THE CAPTURE AND SHARE SURVEY
  const getUserWonCaptureAndShareStatus = React.useCallback(async () => {
    const token = JSON.parse(localStorage.getItem("token"));
    const result = await LoyaltyService.fetchCaptureShare(
      userDetails?.msisdn,
      "CNS_FEB_25",
      token
    );

    if (
      result?.success &&
      result?.data?.entries?.length > 0 &&
      result?.data?.entries[0].state === "won"
    ) {
    }
  }, [userDetails]);

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];

  const [offers, setOffers] = useState([]);

  useEffect(() => {
    const initialOffers = [
      { name: "Offers", isActive: false, id: 5, element: <OffersView /> },
      { name: "Loyalty", isActive: false, id: 2, element: <LoyaltyView /> },
      { name: "Events", isActive: false, id: 4, element: <EventsView /> },
      { name: "Gaming", isActive: false, id: 3, element: <GamingView /> },
      { name: "Quotes", isActive: false, id: 6, element: <QuoteView /> },
      { name: "PeerTalk", isActive: false, id: 8, element: <PeerTalkView /> },
    ];

    if (isUserWhitelisted) {
      initialOffers.unshift({
        name: "Refer",
        isActive: true,
        id: 1,
        element: <ReferAndEarnView />,
      });
    } else {
      initialOffers[0].isActive = true;
    }

    setOffers(initialOffers);
  }, [isUserWhitelisted]);

  const foundElement = offers.find((offer) => offer.isActive);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const changeOfferTab = (id) => {
    const update = offers.map((offer) =>
      id === offer.id
        ? { ...offer, isActive: true }
        : { ...offer, isActive: false }
    );
    setOffers(update);
  };

  useEffect(() => {
    if (tabid) {
      changeOfferTab(parseInt(tabid));
    }
  }, [tabid]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (action === "moviemania") {
        history.push("/loyalty/moviemania");
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [search]);

  // useEffect(() => {
  //   if (!(hasOptedIn === false || hasOptedIn === true)) {
  //     setIsOpenOptInRequestDialog(true);
  //   }
  // }, [hasOptedIn]);

  const onCloseOptInRequestDialog = async (resp) => {
    setHasOptedIn(resp);
    // Place request to server
    await submitOptInStatus(resp);
    setIsOpenOptInRequestDialog(false);
  };

  const trackEvent = async (eventName, eventParams = {}) => {
    try {
      const anl = await analytics();
      logEvent(anl, eventName, eventParams);
    } catch (error) {
      console.error(`Error logging event: ${eventName}`, error);
    }
  };

  const SURVEY_KEY = "PTK_NS_JUNE_25";

  const hasSeenSurveyModal = localStorage.getItem(SURVEY_KEY);
  useEffect(() => {
    if (!hasSeenSurveyModal && loyaltyOffersData?.length > 0) {
      setIsTakeSurveyModalOpen(true);
      // setIsTakeSurveyModalOpen(true)
    }
  }, [loyaltyOffersData]);

  const handleCloseTakeSurveyModal = () => {
    setIsTakeSurveyModalOpen(false);
    localStorage.setItem(SURVEY_KEY, "true");
  };

  //! RENDER ONLY ONCE FOR NOW TO SEE

  const PROMPT_KEY = "peerTalk_tuesday-17-06-25_prompt";

  useEffect(() => {
    const oldKey = "peerTalk_tuesday-1-06-25_prompt";

    if (localStorage.getItem(oldKey)) {
      localStorage.removeItem(oldKey);
    }

    const hasSeenPrompt = localStorage.getItem(PROMPT_KEY);

    if (!hasSeenPrompt && hasSeenSurveyModal && loyaltyOffersData?.length > 0) {
      setIsNewNotificationDialog(true);
      // setIsTakeSurveyModalOpen(true);
    }
  }, [loyaltyOffersData]);

  const onCloseisNewNotificationDialog = () => {
    setIsNewNotificationDialog(false);
    localStorage.setItem(PROMPT_KEY, "true");
  };

  const trackAndNavigate = (eventName, path) => {
    trackEvent(eventName);
    history.push(path);
    localStorage.setItem(PROMPT_KEY, "true");
  };

  return {
    showFeatureRatings,
    isFeatureAlert,
    featureName,
    featureRef,
    loyaltyOffersData,
    loyaltyCheckCode,
    checkOffers,
    getMovieList,
    newFeatureRatings,
    hideNewFeatureRatings,
    getActiveFeatureRatings,
    submitFeatureRatings,
    setSelectedLoyaltyData,
    offerModal,
    setOfferModal,
    checkMovieManiaStatus,
    newInteractions,
    section,
    title,
    feature,
    feedback,
    completedFeature,
    isTakeSurveyModalOpen,
    fastestFingerData,
    fetchUserProfile,
    userProfilephoto,
    userDetails,
    isFetchingUserProfile,
    isUserWhitelisted,
    background,
    mashupBackground,
    foundElement,
    isModalOpen,
    setIsModalOpen,
    changeOfferTab,
    history,
    offers,
    setCompletedFeature,
    interactionID,
    surveyCode,
    handleCloseTakeSurveyModal,
    hasOptedIn,
    isOpenOptInRequestDialog,
    onCloseOptInRequestDialog,
    trackEvent,
    unreadCount,
    isNewNotificationDialog,
    onCloseisNewNotificationDialog,
    trackAndNavigate,
    showTaskResumptionModal,
    setShowTaskResumptionModal,
  };
};

export default useHome;
